import { Box, CircularProgress, MenuItem, Typography } from '@mui/material';
import {
  GeneralFormBox,
  HorizontalForm,
  CustomTextField,
  CustomSelect,
  CustomButton,
} from '../../../common/components';

const CollectingEntitiesFilters = ({
  filters,
  loading,
  error,
  plans,
  groups,
  legalEntities,
  catalogsLoading,
  onFilterChange,
  onSubmit,
  reportOptions = [],
}) => {
  const collectingEntities = (legalEntities || []).filter(
    (entity) =>
      entity?.is_intermediate_entity === true ||
      entity?.is_intermediate_entity === 1 ||
      entity?.is_intermediate_entity === '1'
  );
  console.log('collectingEntities', legalEntities);
  return (
    <GeneralFormBox component="form" onSubmit={onSubmit}>
      <HorizontalForm>
        <CustomSelect
          label="Tipo de reporte"
          name="reportType"
          value={filters.reportType}
          onChange={onFilterChange}
          sx={{ width: '200px', mr: 1.5 }}
        >
          {reportOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomTextField
          label="Fecha Desde"
          type="date"
          name="dateStart"
          value={filters.dateStart}
          onChange={onFilterChange}
          InputLabelProps={{ shrink: true }}
          required
          sx={{ width: '230px', mr: 1.5 }}
        />

        <CustomTextField
          label="Fecha Hasta"
          type="date"
          name="dateEnd"
          value={filters.dateEnd}
          onChange={onFilterChange}
          InputLabelProps={{ shrink: true }}
          required
          sx={{ width: '230px', mr: 1.5 }}
        />

        <CustomSelect
          label="Plan"
          name="plan"
          value={filters.plan}
          onChange={onFilterChange}
          sx={{ width: '220px', mr: 1.5 }}
          disabled={catalogsLoading}
        >
          <MenuItem value="all">Todos</MenuItem>
          {plans.map((plan) => (
            <MenuItem key={plan.uuid} value={plan.uuid}>
              {plan.name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label="Entidad"
          name="legalEntity"
          value={filters.legalEntity}
          onChange={onFilterChange}
          sx={{ width: '260px', mr: 1.5 }}
          disabled={catalogsLoading}
        >
          <MenuItem value="all">Todas</MenuItem>
          {collectingEntities.map((entity) => (
            <MenuItem key={entity.uuid} value={entity.uuid}>
              {entity.legal_business_name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label="Grupo"
          name="group"
          value={filters.group}
          onChange={onFilterChange}
          sx={{ width: '200px', mr: 1.5 }}
          disabled={catalogsLoading}
        >
          <MenuItem value="all">Todos</MenuItem>
          {groups.map((group) => (
            <MenuItem key={group.uuid} value={group.uuid}>
              {group.name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label="Con casa"
          name="whitHouse"
          value={filters.whitHouse}
          onChange={onFilterChange}
          sx={{ width: '200px' }}
        >
          <MenuItem value="not_selected">Todos</MenuItem>
          <MenuItem value="1">Si</MenuItem>
          <MenuItem value="0">No</MenuItem>
        </CustomSelect>
      </HorizontalForm>

      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, my: 2 }}>
        <CustomButton variant="base" color="primary" type="submit" disabled={loading}>
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Ver Reporte'}
        </CustomButton>
      </Box>
    </GeneralFormBox>
  );
};

export default CollectingEntitiesFilters;
